/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { StudentProfile } from '../models/student-profile';
import { studentprofileIdSkilldGenerateUrlGet } from '../fn/skilld/studentprofile-id-skilld-generate-url-get';
import { StudentprofileIdSkilldGenerateUrlGet$Params } from '../fn/skilld/studentprofile-id-skilld-generate-url-get';
import { studentprofileIdSkilldGetProfileGet$Json } from '../fn/skilld/studentprofile-id-skilld-get-profile-get-json';
import { StudentprofileIdSkilldGetProfileGet$Json$Params } from '../fn/skilld/studentprofile-id-skilld-get-profile-get-json';
import { studentprofileIdSkilldGetProfileGet$Plain } from '../fn/skilld/studentprofile-id-skilld-get-profile-get-plain';
import { StudentprofileIdSkilldGetProfileGet$Plain$Params } from '../fn/skilld/studentprofile-id-skilld-get-profile-get-plain';

@Injectable({ providedIn: 'root' })
export class SkilldService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `studentprofileIdSkilldGenerateUrlGet()` */
  static readonly StudentprofileIdSkilldGenerateUrlGetPath = '/studentprofile/{id}/skilld/generate-url';

  /**
   * Generates a URL for the provided student profile ID with a random string GUID.
   * Updates the student profile with a timestamp and the generated GUID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `studentprofileIdSkilldGenerateUrlGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  studentprofileIdSkilldGenerateUrlGet$Response(params: StudentprofileIdSkilldGenerateUrlGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = studentprofileIdSkilldGenerateUrlGet(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Generates a URL for the provided student profile ID with a random string GUID.
   * Updates the student profile with a timestamp and the generated GUID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `studentprofileIdSkilldGenerateUrlGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  studentprofileIdSkilldGenerateUrlGet(params: StudentprofileIdSkilldGenerateUrlGet$Params, context?: HttpContext): Observable<void> {
    const resp = this.studentprofileIdSkilldGenerateUrlGet$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `studentprofileIdSkilldGetProfileGet()` */
  static readonly StudentprofileIdSkilldGetProfileGetPath = '/studentprofile/{id}/skilld/get-profile';

  /**
   * Gets the student profile if the provided random string GUID matches
   * and the request is done within 1 hour of the generated timestamp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `studentprofileIdSkilldGetProfileGet$Plain()` instead.
   *
   * This method doesn't expect any request body.
   */
  studentprofileIdSkilldGetProfileGet$Plain$Response(params: StudentprofileIdSkilldGetProfileGet$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
    const obs = studentprofileIdSkilldGetProfileGet$Plain(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the student profile if the provided random string GUID matches
   * and the request is done within 1 hour of the generated timestamp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `studentprofileIdSkilldGetProfileGet$Plain$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  studentprofileIdSkilldGetProfileGet$Plain(params: StudentprofileIdSkilldGetProfileGet$Plain$Params, context?: HttpContext): Observable<StudentProfile> {
    const resp = this.studentprofileIdSkilldGetProfileGet$Plain$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfile>): StudentProfile => r.body)
    );
  }

  /**
   * Gets the student profile if the provided random string GUID matches
   * and the request is done within 1 hour of the generated timestamp.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `studentprofileIdSkilldGetProfileGet$Json()` instead.
   *
   * This method doesn't expect any request body.
   */
  studentprofileIdSkilldGetProfileGet$Json$Response(params: StudentprofileIdSkilldGetProfileGet$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<StudentProfile>> {
    const obs = studentprofileIdSkilldGetProfileGet$Json(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets the student profile if the provided random string GUID matches
   * and the request is done within 1 hour of the generated timestamp.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `studentprofileIdSkilldGetProfileGet$Json$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  studentprofileIdSkilldGetProfileGet$Json(params: StudentprofileIdSkilldGetProfileGet$Json$Params, context?: HttpContext): Observable<StudentProfile> {
    const resp = this.studentprofileIdSkilldGetProfileGet$Json$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<StudentProfile>): StudentProfile => r.body)
    );
  }

}
